"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runContractFunction = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var evm_utils_1 = require("@moralisweb3/evm-utils");
var EvmChainResolver_1 = require("../EvmChainResolver");
var method = 'post';
var bodyParams = ['abi', 'params'];
exports.runContractFunction = (0, api_utils_1.createEndpointFactory)(function (core) {
    return (0, api_utils_1.createEndpoint)({
        name: 'runContractFunction',
        urlParams: ['address'],
        getUrl: function (params) { return "/".concat(params.address, "/function"); },
        apiToResult: function (data) {
            return data;
        },
        resultToJson: function (data) { return data; },
        parseParams: function (params) { return ({
            chain: EvmChainResolver_1.EvmChainResolver.resolve(params.chain, core).apiHex,
            function_name: params.functionName,
            address: evm_utils_1.EvmAddress.create(params.address, core).lowercase,
            abi: params.abi,
            params: params.params,
        }); },
        method: method,
        bodyParams: bodyParams,
    });
});
